import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const giftCardsApi = createApi({
    reducerPath: 'giftCardsApi',
    tagTypes: ['giftCards'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getGiftCards: build.query({
            query: (data) => ({
                url: api.giftCards.getGiftCards(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ['giftCards']
        }),
        getSingleGiftCard: build.query({
            query: ({ id, ...data} ) => ({
                url: api.giftCards.getSingleGiftCard(id),
                method: 'GET',
                params: data
            }),
        }),
        createGiftCard: build.mutation({
            query: (data) => ({
                url: api.giftCards.createGiftCard(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        giftCardsApi.util.updateQueryData('getGiftCards', patch, (draft) => {
                            draft.unshift(data)
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
        }),
        updateGiftCard: build.mutation({
            query: ({id, ...data}) => ({
                url: api.giftCards.updateGiftCard(id),
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        giftCardsApi.util.updateQueryData('getGiftCards',  {location_id: patch.location_id} , (draft) => {
                            const itemIndex = draft?.findIndex(item => item.id === patch.id)
                            if (itemIndex !== -1) {
                                draft[itemIndex] = data
                            }
                        })
                    )
                } catch(e) {
                    console.error('Update failed:', e)
                }
            },
        }),
        deleteGiftCard: build.mutation({
            query: ({ id, ...data }) => ({
                url: api.giftCards.deleteGiftCard(id),
                method: 'DELETE',
                params: data,
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(
                        giftCardsApi.util.updateQueryData('getGiftCards', {location_id: patch.location_id}, (draft) => {
                            const index = draft.findIndex((giftCard) => giftCard.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            } else {
                                console.warn('Gift Card not found in cache')
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
        }),
    })
})

export const { useDeleteGiftCardMutation, useGetSingleGiftCardQuery, useUpdateGiftCardMutation } = giftCardsApi
